import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api.tanaescola.com/api',
  //baseURL: 'http://localhost:5000/api',
 // baseURL: 'https://api-hml.tanaescola.com:8443/api',  
});

// Ensure Authorization header is present on app start and after HMR/reloads
try {
  const storedToken = JSON.parse(localStorage.getItem('token'));
  if (storedToken) {
    instance.defaults.headers.common['authorization'] = 'Bearer ' + storedToken;
  }
} catch (e) {
  // ignore malformed token
}

// Keep Authorization header in sync with localStorage for every request
instance.interceptors.request.use(
  (config) => {
    try {
      const currentToken = JSON.parse(localStorage.getItem('token'));
      if (currentToken) {
        config.headers = config.headers || {};
        config.headers['authorization'] = 'Bearer ' + currentToken;
      }
    } catch (e) {
      // ignore
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;